import React, { useEffect, useState, useCallback } from "react";
import axios from "axios";

const API = "https://tulithevlogger.com/api/admin/users";

const AdminUsers = () => {

  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(false);

  const token = localStorage.getItem("token");

  // =========================
  // LOAD USERS
  // =========================
  const loadUsers = useCallback(async () => {

    try {

      setLoading(true);

      const res = await axios.get(API, {
        headers: {
          Authorization: `Bearer ${token}`
        }
      });

      const data = res.data.data || res.data || [];

      setUsers(data);

    } catch (err) {

      console.error("LOAD USERS ERROR:", err);

    } finally {

      setLoading(false);
    }

  }, [token]);

  // =========================
  // INITIAL LOAD
  // =========================
  useEffect(() => {
    loadUsers();
  }, [loadUsers]);

  return (

    <div style={styles.page}>

      <h2 style={styles.title}>
        👥 User Management
      </h2>

      <div style={styles.card}>

        <table style={styles.table}>

          <thead>

            <tr>

              <th style={styles.th}>ID</th>

              <th style={styles.th}>Name</th>

              <th style={styles.th}>Email</th>

              <th style={styles.th}>Phone</th>

              <th style={styles.th}>Role</th>

              <th style={styles.th}>Status</th>

              <th style={styles.th}>Created</th>

            </tr>

          </thead>

          <tbody>

            {loading ? (

              <tr>
                <td colSpan="7" style={styles.empty}>
                  Loading users...
                </td>
              </tr>

            ) : users.length === 0 ? (

              <tr>
                <td colSpan="7" style={styles.empty}>
                  No users found
                </td>
              </tr>

            ) : (

              users.map((u) => (

                <tr key={u.id}>

                  <td style={styles.td}>
                    {u.id}
                  </td>

                  <td style={styles.td}>
                    {u.name}
                  </td>

                  <td style={styles.td}>
                    {u.email}
                  </td>

                  <td style={styles.td}>
                    {u.phone || "-"}
                  </td>

                  <td style={styles.td}>
                    {u.role || "Customer"}
                  </td>

                  <td style={styles.td}>

                    <span
                      style={{
                        ...styles.badge,
                        background:
                          u.isactive
                            ? "#d4edda"
                            : "#f8d7da",
                        color:
                          u.isactive
                            ? "#155724"
                            : "#721c24"
                      }}
                    >
                      {u.isactive ? "Active" : "Inactive"}
                    </span>

                  </td>

                  <td style={styles.td}>

                    {u.createdat
                      ? new Date(
                          u.createdat
                        ).toLocaleDateString()
                      : "-"}

                  </td>

                </tr>

              ))
            )}

          </tbody>

        </table>

      </div>

    </div>
  );
};

export default AdminUsers;

// =========================
// STYLES
// =========================

const styles = {

  page: {
    padding: 20,
    background: "#f4f6f9",
    minHeight: "100vh"
  },

  title: {
    marginBottom: 20,
    fontSize: 28
  },

  card: {
    background: "#fff",
    borderRadius: 10,
    overflow: "hidden",
    border: "1px solid #ddd"
  },

  table: {
    width: "100%",
    borderCollapse: "collapse"
  },

  th: {
    background: "#f8f9fa",
    border: "1px solid #ddd",
    padding: 12,
    textAlign: "left",
    fontSize: 14
  },

  td: {
    border: "1px solid #ddd",
    padding: 12,
    fontSize: 14
  },

  empty: {
    textAlign: "center",
    padding: 30
  },

  badge: {
    padding: "5px 10px",
    borderRadius: 20,
    fontSize: 12,
    fontWeight: "bold"
  }
};